import { useHasPermission } from '../../../../api/authorization.provider';

export type BeaconCuttingPermissionField = '*' | 'startAt';
export type BeaconWeldingPermissionField = '*' | 'startAt';

const useHasBeaconCuttingFieldPermission = (
  machineId: string | undefined,
  field: BeaconWeldingPermissionField
) => {
  return useHasApplicationFieldFieldPermission(
    'beacon_cutting',
    machineId,
    field
  );
};

const useHasBeaconWeldingFieldPermission = (
  machineId: string | undefined,
  field: BeaconWeldingPermissionField
) => {
  return useHasApplicationFieldFieldPermission(
    'beacon_welding',
    machineId,
    field
  );
};

const useHasApplicationFieldFieldPermission = (
  appSlug: string,
  machineId: string | undefined,
  field: BeaconWeldingPermissionField
) => {
  return useHasPermission(
    'update',
    appSlug,
    {
      machineId,
    },
    field
  );
};

export {
  useHasBeaconCuttingFieldPermission,
  useHasBeaconWeldingFieldPermission,
  useHasApplicationFieldFieldPermission,
};
